import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AUTH } from 'src/app/auth/components/login/types/login.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthReverseGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem(AUTH.TOKEN); // Get token from session storage

    if (token && !this.isTokenExpired(token)) {
      // If token is valid, redirect to another page (e.g., home)
      this.router.navigate(['/dashboard']); // Adjust this route as needed
      return false; // Prevent access to login
    }

    return true; // Allow access to login if no valid token
  }

  isTokenExpired(token: string): boolean {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
